import {createSelector} from 'reselect';
import props from '../../../props';

export default createSelector(
    props.vip20.bonuses.freeplay,
    props.vip20.level_preset,
    props.vip20.buttons.freeplay,
    (bonus, level_preset, button) => {
        return {
            bonus,
            level_preset,
            button
        }
    }
)